/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portalnotify_Empty_BodyInputs */



/**
* | output |
* | --- |
* | "Updates from the team about your projects, invoices and approvals appear here." |
*
* @param {Portalnotify_Empty_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portalnotify_empty_body = /** @type {((inputs?: Portalnotify_Empty_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portalnotify_Empty_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Updates from the team about your projects, invoices and approvals appear here.")
});